module.exports = __webpack_public_path__ + "static/media/ikea-logo.f88b07ce.svg";